/// <amd-module name="Wit/LinkedWorkItemsDropdown/RestClient/Git" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\wit\vss-work-web\wit-linked-work-items-dropdown\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as VS_Services from "VSS/Platform/Contracts/WebApi";

export interface IGitRestClient extends IVssRestClient {
    /**
     * Retrieve a list of work items associated with a pull request.
     * 
     * @param repositoryId - ID or name of the repository.
     * @param pullRequestId - ID of the pull request.
     * @param project - Project ID or project name
     */
    getPullRequestWorkItemRefs(repositoryId: string, pullRequestId: number, project?: string): Promise<VS_Services.ResourceRef[]>;
}

class GitRestClient extends RestClientBase implements IGitRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Retrieve a list of work items associated with a pull request.
     * 
     * @param repositoryId - ID or name of the repository.
     * @param pullRequestId - ID of the pull request.
     * @param project - Project ID or project name
     */
    public async getPullRequestWorkItemRefs(
        repositoryId: string,
        pullRequestId: number,
        project?: string
        ): Promise<VS_Services.ResourceRef[]> {

        return this.beginRequest<VS_Services.ResourceRef[]>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "{project}/_apis/git/repositories/{repositoryId}/pullRequests/{pullRequestId}/workitems",
            routeValues: {
                project: project,
                repositoryId: repositoryId,
                pullRequestId: pullRequestId
            }
        });
    }

}

export const GitClientName = "WIT.PRDetails.Extensions.IGitRestClient";

export function getGitClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IGitRestClient {
    return pageContext.getRestClient<IGitRestClient>(GitClientName, options);
}

RestClients.add(GitClientName, { 
    factory: GitRestClient,
    options: {
        resourceAreaId: "4e080c62-fa21-4fbc-8fef-2a10a2b38049",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
